import { Formik, Form } from 'formik'
import { useMemo } from 'react'
import cn from 'classnames'

import { SortField } from '@components/forms/SortField'
import { SelectButtonField } from '@components/forms/SelectButtonField'
import { PrimaryTypeEnum } from '@interfaces/PrimaryTypeEnum'
import { SortEnum } from '@interfaces/SortEnum'
import { OrderedKeyEnum } from '@interfaces/OrderedEnum'
import { RecommendTypeSearchEnum } from '@interfaces/RecommendTypeSearchEnum'
import { AdvancedSearchFormProps } from './interface'
import { TriggerPrimaryTypeChange } from './TriggerPrimaryTypeChange'

const defaultTypeOptions1 = [
  { value: RecommendTypeSearchEnum.WHOLE, text: 'ตอนเดียว' },
  { value: RecommendTypeSearchEnum.CHAPTER, text: 'มีมากกว่า 1 ตอน' },
]

const defaultTypeOptions2 = [
  { value: RecommendTypeSearchEnum.ENDED, text: 'จบแล้ว' },
  { value: RecommendTypeSearchEnum.NOT_END, text: 'ยังไม่จบ' },
]

export function AdvancedSearchForm({
  className,
  orderBy,
  primaryType,
  secondaryType,
  showAdvancedSearch,
  getOrderBy,
  handleSubmit,
}: AdvancedSearchFormProps) {
  const orderByOptions = useMemo(() => {
    if (primaryType === PrimaryTypeEnum.HOT_NEW) {
      return [
        {
          title: 'ความนิยม',
          value: `${OrderedKeyEnum.POPULAR}:${SortEnum.DESC}`,
          label: 'มาก - น้อย',
        },
      ]
    }

    if ([PrimaryTypeEnum.NEW, PrimaryTypeEnum.ENDED].includes(primaryType)) {
      return [
        {
          title: 'วันอัปเดต',
          value: `${OrderedKeyEnum.UPDATED_AT}:${SortEnum.DESC}`,
          label: 'ใหม่ - เก่า',
        },
        {
          title: 'ความนิยม',
          value: `${OrderedKeyEnum.POPULAR}:${SortEnum.DESC}`,
          label: 'มาก - น้อย',
        },
      ]
    }

    if (primaryType === PrimaryTypeEnum.TOP_CHART) {
      return [
        {
          title: 'เรื่องฮิตขายดี',
          value: `${OrderedKeyEnum.PURCHASED}:${SortEnum.DESC}`,
          label: 'มาก - น้อย',
        },
        {
          title: 'ความนิยม',
          value: `${OrderedKeyEnum.POPULAR}:${SortEnum.DESC}`,
          label: 'มาก - น้อย',
        },
      ]
    }

    return [
      {
        title: 'เรียงตามวันที่สร้าง',
        value: `${OrderedKeyEnum.CREATED_AT}:${SortEnum.DESC}`,
        label: 'ใหม่ - เก่า',
      },
      {
        title: 'เรียงตามวันที่สร้าง',
        value: `${OrderedKeyEnum.CREATED_AT}:${SortEnum.ASC}`,
        label: 'เก่า - ใหม่',
      },
      {
        title: 'ความนิยม',
        value: `${OrderedKeyEnum.POPULAR}:${SortEnum.DESC}`,
        label: 'มาก - น้อย',
      },
      {
        title: 'ความนิยม',
        value: `${OrderedKeyEnum.POPULAR}:${SortEnum.ASC}`,
        label: 'น้อย - มาก',
      },
    ]
  }, [primaryType])

  const secondaryTypeOptions = useMemo(() => {
    if (
      [PrimaryTypeEnum.ENDED, PrimaryTypeEnum.TOP_CHART].includes(primaryType)
    ) {
      return []
    }

    // return [...defaultTypeOptions1, ...defaultTypeOptions2]
    return defaultTypeOptions2
  }, [primaryType])

  return (
    <Formik
      initialValues={{
        secondaryType,
        orderBy,
      }}
      onSubmit={handleSubmit}
    >
      {({ setFieldValue, submitForm }) => (
        <Form
          className={cn(
            'flex desktop-tablet:items-end desktop-tablet:space-x-[20px] pb-[20px] mb-[20px] border-b border-b-gray-3 dark:border-purple mobile:flex-col mobile:space-y-[20px]',
            className
          )}
        >
          <TriggerPrimaryTypeChange
            primaryType={primaryType}
            orderBy={orderBy}
            secondaryType={secondaryType}
            showAdvancedSearch={showAdvancedSearch}
          />
          <SortField
            className='max-w-[400px] w-full'
            name='orderBy'
            isShowLabel
            options={orderByOptions}
          />
          {secondaryTypeOptions.length !== 0 && (
            <SelectButtonField
              name='secondaryType'
              label='ประเภท'
              options={secondaryTypeOptions}
              mode='line'
            />
          )}
          <div className='flex-1 mobile:hidden' />
          <div className='ml-auto font-mitr font-medium text-[14px]'>
            <button
              type='button'
              className='underline dark:text-dark-10 py-[10px] px-[20px]'
              onClick={() => {
                const newOrderBy = getOrderBy(primaryType)
                setFieldValue('orderBy', newOrderBy)
                setFieldValue('secondaryType', undefined)
                submitForm()
              }}
            >
              ล้างค่า
            </button>
            <button
              type='submit'
              className='py-[10px] px-[20px] rounded-[20px] bg-primary dark:bg-purple text-white dark:text-white-2'
            >
              ค้นหา
            </button>
          </div>
        </Form>
      )}
    </Formik>
  )
}
